import { useCallback, useEffect, useState } from 'react'
import {
  COPILOT_SETTINGS_STORAGE_KEY,
  CopilotSettings,
  DEFAULT_COPILOT_SETTINGS,
} from '@/features/copilot/constants'

const readSettings = (): CopilotSettings => {
  try {
    const raw = window.localStorage.getItem(COPILOT_SETTINGS_STORAGE_KEY)
    if (!raw) return DEFAULT_COPILOT_SETTINGS
    const parsed = JSON.parse(raw) as Partial<CopilotSettings>
    return { ...DEFAULT_COPILOT_SETTINGS, ...parsed }
  } catch (error) {
    console.error('Failed to read copilot settings from localStorage:', error)
    return DEFAULT_COPILOT_SETTINGS
  }
}

const writeSettings = (settings: CopilotSettings): void => {
  try {
    window.localStorage.setItem(
      COPILOT_SETTINGS_STORAGE_KEY,
      JSON.stringify(settings),
    )
  } catch (error) {
    console.error('Failed to write copilot settings to localStorage:', error)
  }
}

export const useCopilotSettings = () => {
  const [settings, setSettings] = useState<CopilotSettings>(readSettings)

  useEffect(() => {
    writeSettings(settings)
  }, [settings])

  const updateSettings = useCallback((patch: Partial<CopilotSettings>) => {
    setSettings((prev) => ({ ...prev, ...patch }))
  }, [])

  const resetSettings = useCallback(() => {
    setSettings(DEFAULT_COPILOT_SETTINGS)
  }, [])

  return { settings, updateSettings, resetSettings }
}
